import Typography from "@/src/elections/components/Typography"
import classNames from "classnames"

const WelcomeBanner = ({
  title,
  description,
  className
}: {
  title: string
  description?: string
  className?: string
}) => (
  <>
    <div
      className={classNames(
        "w-full px-6 py-8 md:px-24 md:py-10 bg-cover",
        "bg-welcome md:bg-welcome-desktop",
        className
      )}
    >
      <Typography className="md:hidden text-white text-center" type="p20">
        {title}
      </Typography>
      <Typography
        className="-md:hidden md:max-w-[700px] md:mx-auto text-white text-center"
        type="p32"
        weight="medium"
      >
        {title}
      </Typography>
      {description ? (
        <>
          <Typography className="md:hidden text-white text-center" type="p15">
            {description}
          </Typography>
          <Typography
            className="-md:hidden md:max-w-[700px] md:mx-auto text-white text-center"
            type="p20"
            weight="medium"
          >
            {description}
          </Typography>
        </>
      ) : null}
    </div>
    <div className="flex flex-row justify-items-stretch">
      <div className="h-2 md:h-3 w-full bg-green-600" />
      <div className="h-2 md:h-3 w-full bg-white" />
      <div className="h-2 md:h-3 w-full bg-green-600" />
    </div>
  </>
)

export default WelcomeBanner
